import { loadStripe } from '@stripe/stripe-js';

/**
 * Stripe.js instance factory for Connect.
 *
 * For STANDARD connected accounts we use DIRECT charges, which means any client-side
 * confirmation (Embedded Checkout, confirmCardPayment) must run against a Stripe.js
 * instance initialised with { stripeAccount: <connectedAccountId> }. For legacy
 * EXPRESS/CUSTOM accounts (destination charges) we use the plain platform instance.
 *
 * loadStripe must be called once per account, so we cache the promise per account id.
 */
const PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51234567890abcdef';

const cache = {};

/**
 * @param {string|null} stripeAccountId - connected account id for a Standard provider,
 *   or null/undefined to use the platform instance.
 * @returns {Promise<Stripe>}
 */
export const getStripePromise = (stripeAccountId) => {
  const key = stripeAccountId || 'platform';
  if (!cache[key]) {
    cache[key] = stripeAccountId
      ? loadStripe(PUBLISHABLE_KEY, { stripeAccount: stripeAccountId })
      : loadStripe(PUBLISHABLE_KEY);
  }
  return cache[key];
};

/**
 * Resolve the connected account id to bind Stripe.js to, given a business row.
 * Returns the connected account id only for Standard accounts (direct charges);
 * otherwise null so the platform instance is used.
 */
export const connectedAccountIdForBusiness = (business) =>
  business?.stripe_account_type === 'standard' ? business?.stripe_id || null : null;

export default getStripePromise;
